<template>
  <div :class="{ invalid: !isValid, valid: isValid }">
    <label :for="name">{{ label }}</label>
    <div v-if="!isValid" class="error">{{ errorDescription }}</div>
    <select
      @change="$emit('input', $event.target.value)"
      :class="{ 'top-margin': hasTopMargin }"
      :name="name"
      @focus="emitFocus"
    >
      <option
        v-for="(option, index) in this.options"
        :key="index"
        :selected="option.name == value"
        :value="option.name"
      >
        {{ option.name }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  computed: {},
  props: {
    label: String,
    name: String,
    options: Array,
    value: String,
    hasTopMargin: {
      type: Boolean,
      default: false
    },
    onFocus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isValid: true,
      errorDescription: "Test can not be empty"
    };
  },
  methods: {
    emitFocus() {
      if (this.onFocus) {
        this.$emit("gotFocus", true);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";
@import "@/style/components/selects";

select.top-margin {
  margin-top: 10px;
  margin-bottom: auto;
}
</style>
